import { useEffect, useState } from "react";
import { toast } from "sonner";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

// Shared PWA install state: exposes the deferred prompt, installed status and an install trigger.
export const usePwaInstall = () => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const ios = isIOS();

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); toast.success("IMPERIUM installé sur votre appareil 🎉"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch { /* noop */ }
      setDeferred(null);
      return;
    }
    if (ios) {
      toast.info("Sur iPhone/iPad : appuyez sur Partager ⬆️ puis « Sur l'écran d'accueil »", { duration: 6000 });
    }
  };

  // Show install UI when the browser offers a prompt, or on iOS (manual steps).
  const canInstall = !installed && (!!deferred || ios);

  return { canInstall, installed, ios, promptInstall };
};
